// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'browser-solid';

export const Component = () => (
  <path d='M0 21.53V8.007h25v13.525c0 .44-.147.781-.44 1.025-.294.293-.635.44-1.075.44H1.515c-.44 0-.782-.147-1.075-.44C.147 22.312 0 21.97 0 21.53ZM25 3.515V7.03H0V3.514c0-.44.147-.781.44-1.074.294-.293.635-.44 1.075-.44h21.97c.44 0 .782.147 1.075.44.293.293.44.634.44 1.074ZM2.98 5.027V4.002h-.977v1.025h.977Zm2.001 0V4.002h-.976v1.025h.976Zm2.002 0V4.002h-.977v1.025h.977Zm17.04.977v-2.49c0-.342-.195-.488-.537-.488H8.985v2.978h15.038Z' />
);

export const viewBox = '0 0 25 25';
